import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const VisibleSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
    <path d="M46.4,23.73c-8.11-8.33-16.47-12.25-24.89-11.63C9.06,13.01,1.32,23.51,1,23.96c-.61.84-.48,2,.3,2.68,7.46,6.55,15.17,9.86,22.95,9.86.61,0,1.22-.02,1.84-.06,12.28-.82,20.07-9.61,20.4-9.98.68-.78.65-1.96-.08-2.71ZM23.79,29.7c-3.06,0-5.54-2.49-5.54-5.54s2.49-5.54,5.54-5.54,5.54,2.49,5.54,5.54-2.49,5.54-5.54,5.54ZM17.65,16.85c-2.08,1.75-3.41,4.37-3.41,7.3s1.41,5.7,3.59,7.45c-4.16-1.14-8.31-3.38-12.42-6.72,1.97-2.18,6.3-6.29,12.23-8.03ZM29.31,31.93c2.43-1.73,4.03-4.57,4.03-7.77,0-2.62-1.06-4.99-2.77-6.72,3.85,1.45,7.72,4.02,11.57,7.7-2.12,1.93-6.66,5.44-12.82,6.79Z" />
  </svg>
);

const VisibleIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={VisibleSvg} />
);

export default VisibleIcon;
